import { TourSalesModel, useCreateTourSale } from 'api-hooks/tour/tour-sale';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { SeparatorVertical } from 'components/styles';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { NavigationProps } from 'types';

import TourSaleForm from './components/form';
import { TourSaleFormType } from './components/form-type';

export type TourSaleCreateParams = {
  defaultValues?: TourSaleFormType;
  tourSale?: TourSalesModel;
};

export default function TourSaleCreate(
  props: NavigationProps<NavigationRoutes.TourSalesCreate>,
) {
  const { mutateAsync, error } = useCreateTourSale();
  const onResolve = useApprovalableEdit('tour-sales');

  return (
    <>
      <TourSaleForm
        defaultValues={props.navigation.params?.defaultValues}
        errorRender={
          !!error &&
          !!error.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )
        }
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
